import {AfterViewInit, Component, EventEmitter, HostListener, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import SignaturePad from 'signature_pad';
import {ModalSimpleInterface} from '@app/core/models/modal-simple.interface';
import {ModalSimpleComponent} from '@app/shared/modal-simple/modal-simple.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-digital-signature',
  templateUrl: './digital-signature.component.html',
  styleUrls: ['./digital-signature.component.scss']
})
export class DigitalSignatureComponent implements OnInit, AfterViewInit {
  signaturePad: SignaturePad;
  @Input() title: string;
  @Input() value: string;
  @Output() emit = new EventEmitter<any>();

  cleared = false;

  constructor(
    private dialog: MatDialog
  ) {

  }

  get signaturePadIsEmpty(): boolean {
    return this.signaturePad.isEmpty();
  }

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    const container: HTMLElement = document.getElementById('signature-pad-container');
    const pad: HTMLElement = document.getElementById('signature-pad');
    pad.setAttribute('width', container.offsetWidth.toString());
    pad.setAttribute('height', container.offsetHeight.toString());
    this.signaturePad.clear();
  }

  ngAfterViewInit(): void {
    this.onResize();
  }

  ngOnInit(): void {
    const container: HTMLElement = document.getElementById('signature-pad-container');
    this.signaturePad = new SignaturePad(document.querySelector('canvas'));
    if(this.signaturePad && this.value) {
      this.signaturePad.fromDataURL('data:image/png;base64,' + this.value, { ratio: 1, width: container.offsetWidth, height: container.offsetHeight})
    }
  }

  ngOnChanges(): void {
    const container: HTMLElement = document.getElementById('signature-pad-container');
    if(this.signaturePad && this.value) {
      this.signaturePad.fromDataURL('data:image/png;base64,' + this.value , {ratio: 1, width: container.offsetWidth,  height: container.offsetHeight})
    }
  }

  clearSignature(): void {
    this.cleared = true;
    this.signaturePad.clear();
  }

  saveSignature(): void {
    if(this.cleared && this.signaturePadIsEmpty) {
      const dialogData: ModalSimpleInterface = {
        icon: 'icon-s-alert',
        body: 'Completando l\'azione la firma sarà cancellata.',
        ctaNegative: {
          label: 'Annulla'
        },
        ctaPositive: {
          label: 'Procedi'
        },
      };
      const dialogRef = this.dialog.open(ModalSimpleComponent, {
        data: dialogData
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.emit.emit('');
        }
      });
    } else {
      const dataUrlImage = this.signaturePad.toDataURL('image/png');
      this.emit.emit(dataUrlImage.split(',')[1]);
    }
  }

}
